export default "__VITE_ASSET__CZWN1ED7__"